import { motion } from "framer-motion";
import { ABOUT } from "@/constants/testIds";
import { useLightbox } from "@/components/site/Lightbox";

export const About = () => {
  const { open } = useLightbox();
  const img1 = "https://customer-assets.emergentagent.com/job_portfolio-site-187/artifacts/o73okaok_91be40ef-4a74-4cf2-ac48-64ccedd9510a.jpg";
  const img2 = "https://customer-assets.emergentagent.com/job_portfolio-site-187/artifacts/qdvnovbi_62a96453-b9c4-469f-9d54-0bddcd581e3f.jpg";
  const img3 = "https://customer-assets.emergentagent.com/job_portfolio-site-187/artifacts/jtf6ab3b_d40426de-c564-42a3-9a62-3140fa303911.jpg";
  return (
  <section id="about" data-testid={ABOUT.root} className="py-24 md:py-32 bg-bone-dark">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="md:col-span-5 md:col-start-1"
        >
          <div className="relative h-[78vh] md:h-[88vh]">
            {/* Petal 1 — top */}
            <div
              className="absolute top-0 left-1/2 -translate-x-1/2 w-[58%] overflow-hidden shadow-xl cursor-zoom-in"
              style={{ transform: "translateX(-50%) rotate(-3deg)" }}
              onClick={() => open(img1, "Justis Tan")}
            >
              <img
                src={img1}
                alt="Justis Tan"
                className="w-full h-[36vh] object-cover transition-transform duration-[2000ms] hover:scale-105"
              />
            </div>
            {/* Petal 2 — bottom left */}
            <div
              className="absolute bottom-0 left-0 w-[55%] overflow-hidden shadow-xl cursor-zoom-in"
              style={{ transform: "rotate(-8deg)" }}
              onClick={() => open(img2, "Justis Tan")}
            >
              <img
                src={img2}
                alt="Justis Tan with car"
                className="w-full h-[34vh] object-cover transition-transform duration-[2000ms] hover:scale-105"
              />
            </div>
            {/* Petal 3 — bottom right */}
            <div
              className="absolute bottom-0 right-0 w-[55%] overflow-hidden shadow-xl cursor-zoom-in"
              style={{ transform: "rotate(8deg)" }}
              onClick={() => open(img3, "Justis Tan")}
            >
              <img
                src={img3}
                alt="Justis Tan"
                className="w-full h-[34vh] object-cover transition-transform duration-[2000ms] hover:scale-105"
              />
            </div>
          </div>
          <p className="eyebrow mt-6">On Site — Calgary, AB</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="md:col-span-6 md:col-start-7 md:pt-20"
        >
          <p className="eyebrow mb-6">About</p>
          <h2 className="font-serif text-5xl md:text-6xl leading-[1.05] tracking-tight">
            Calgary-based finishing carpenter on a path to the{" "}
            <span className="italic">full ticket.</span>
          </h2>

          <div className="mt-10 space-y-6 text-ink/75 leading-relaxed max-w-lg">
            <p>
              I&apos;ve been working full-time in finishing carpentry since
              January 2024 with Martinwood Finishing Ltd, subcontracted through
              Echo House Finishing on custom residential homes for builders
              including Light House Homes and Baywest Homes.
            </p>
            <p>
              My day-to-day is doors, baseboards, casings, window trim, and
              custom built-ins — reading blueprints, working alongside other
              trades, and keeping finished surfaces protected from start to
              finish. I&apos;m continuing to develop my skills and am pursuing
              my formal apprenticeship training next.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t hairline pt-8">
            <div>
              <p className="font-serif text-4xl">2024</p>
              <p className="eyebrow mt-2">Started</p>
            </div>
            <div>
              <p className="font-serif text-4xl">YYC</p>
              <p className="eyebrow mt-2">Based In</p>
            </div>
            <div>
              <p className="font-serif text-4xl">Class 5</p>
              <p className="eyebrow mt-2">GDL Licensed</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
  );
};
